import i18n from '../../lang/index'
import util from '../../utils/util'
i18n.locale = util.getCookie("locale") || 'en';
const hostRouter = [{
    path: '/overview',
    component: () => import('@/pages/Index'),
    redirect: {
      name: 'overview'
    },
    children: [{
      name: 'overview',
      path: 'index',
      component: () => import('@/pages/overview/OverView'),
    }]
  },
]
export default hostRouter



// WEBPACK FOOTER //
// ./src/router/modules/host.js